import type { BadgeProps } from './types';
import { useBadge } from './use-badge';

export const Badge = ({ ref, ...props }: BadgeProps) => {
  const { cls, children, ...other } = useBadge(props);

  return (
    <span className={cls} ref={ref} {...other}>
      {children}
    </span>
  );
};
